<template>
  <div :style="siteStyles">
    <div v-if="page === 'account'" class="main-profile">
      <v-container fluid pa-0 pt-4 grid-list-lg v-if="straightSso === false">
        <v-layout row wrap class="coming-soon" v-if="mobileSignup">
          <v-flex xs12>
            <h2 class="text-xs-center mt-3">
              Thanks for completing your one-time registration!
              <br />You can now return to your mobile app and login.
              <br />Remember - you can also access My Alerus from your desktop for a full financial fitness experience.
            </h2>
          </v-flex>
        </v-layout>
        <v-layout px-5 align-center justify-center row wrap fill-height v-else>
          <v-flex align-self-center xs12 v-if="config.maintenance">
            <div class="text-xs-center">
              <h3>{{ config.message }}</h3>
              <!-- <h3>MY ALERUS is currently unavailable due to scheduled maintenance until approximately 8:30pm CDT.
              <br />We apologize for the inconvenience. You can access your Alerus Mobile Banking or Retirement App during this time.</h3>-->
            </div>
          </v-flex>
          <v-flex align-self-center xs12 v-if="links.length || actionButtons.length">
            <div class="text-xs-center">
              <h3>Please select an option below:</h3>
            </div>
          </v-flex>
          <v-flex shrink xs12 sm4 v-for="link in links" :key="link.label">
            <v-card :href="link.url" :target="link.target" raised hover class="admin-link">
              <v-card-text class="text-xs-center">{{ link.label }}</v-card-text>
            </v-card>
          </v-flex>
          <v-flex shrink xs12 sm4 v-for="link in actionButtons" :key="link.label">
            <v-card @click="handleActionButton(link)" raised hover class="admin-link">
              <v-card-text class="text-xs-center">{{ link.label }}</v-card-text>
            </v-card>
          </v-flex>
          <div align-self-center class="customError">{{ authError }}</div>
        </v-layout>
      </v-container>
    </div>
    <div v-else-if="page === 'fullAccount'">
      <!-- <v-btn
        :loading="fullAccountLoading"
        :disabled="fullAccountLoading"
        class="my-4 d-block"
        @click="getFullAccount"
      >Get Full Account</v-btn>-->
      <div v-if="fullAccount">
        <div v-for="(item,i) in fullAccount">{{ i }}: {{ item }}</div>
      </div>
    </div>
    <div v-else-if="page === 'branchLookup'">
      <v-card width="25%" class="my-3"></v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { $authUser, $cognito } from "@/plugins/axios";
import { Promise } from "q";
export default {
  name: "dashboard",
  data() {
    return {
      authUrl: "",
      dialog: false,
      editedItem: {},
      clonedItem: {},
      loadingPercentage: 0,
      tab: null,
      newUrl: false,
      branchLoading: false,
      accountLoading: false,
      actionLoading: false,
      actionTagsLoading: false,
      fullAccountLoading: false,
      system: "",
      // myAlerusMaint: process.env.VUE_APP_MYALERUS_MAINT,
      phoneError: "",
      mfaConfig: {
        mfaTypes: ["TOTP"]
      },
      pagination: {
        descending: true,
        sortBy: "accountName"
      },
      account: [],
      actions: [],
      actionTags: [],
      systems: ["retirement", "avoka", "banking", "wex", "elan", "envestnet"],
      branch: null,
      dashboardReady: false,
      formError: "",
      emailError: "",
      branchInfo: "",
      fullAccount: "",
      token: "",
      authToken: "",
      headers: [
        {
          text: "Account ID",
          sortable: true,
          value: "accountID",
          width: "5"
        },
        { text: "Name", sortable: true, value: "accountName" },
        { text: "Type", sortable: true, value: "accountClassification" },
        {
          text: "Investment Account ID",
          sortable: true,
          value: "investmentAccount"
        },
        { text: "Participant ID", sortable: true, value: "participantId" },
        { text: "Plan #", sortable: true, value: "planNumber" },
        { text: "Provider", sortable: true, value: "providerName" },
        { text: "Status", sortable: true, value: "accountStatus" },
        { text: "Balance", sortable: true, value: "balance" }
      ],
      actionHeaders: [
        { text: "Workout", value: "workout" },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "phoneNumber" }
      ],
      userHeaders: [
        { text: "Username", value: "username" },
        { text: "Alerus 360 ID", value: "alerusId" },
        { text: "CIF", value: "cif" },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "phone" },
        { text: "Date of Birth", value: "dateOfBirth" }
      ]
    };
  },
  watch: {
    async branch() {
      if (this.branch.length === 5) {
        this.branchLoading = true;
        await this.branchLookup(this.branch);
        this.branchLoading = false;
      } else {
        this.branchInfo = "";
      }
    }
  },
  async created() {
    if (this.straightSso) {
      window.location.href = this.links[1].target;
    }
  },
  computed: {
    ...mapState("accounts", ["page"]),
    ...mapState("user", [
      "user",
      "admin",
      "links",
      "actionButtons",
      "wex",
      "mobileSignup",
      "wexLinks",
      "straightSso",
      "config",
      "vendor",
      "mersBranded",
      "authError"
    ]),
    userAtts() {
      return {
        username: this.user.username,
        email: this.user.attributes.email,
        phone: this.user.attributes["phone_number"],
        alerusId: this.user.attributes["custom:alerus360id"],
        cif: this.user.attributes["custom:cif"],
        dateOfBirth: this.user.attributes["custom:dateofbirth"]
      };
    },
    editedPhone() {
      return "+" + this.editedItem.phone;
    },
    primaryColor() {
      return this.mersBranded ? "#2F6C55" : "#297994"
    },
    borderColor() {
      return this.mersBranded ? "#bdce9e" : "#40a8cb";
    },
    buttonColor() {
      return this.mersBranded ? "#33715A" : "#CD493C";
    },
    siteStyles() {
      return {
        '--primary-color-button': this.primaryColor,
        '--border-color': this.borderColor,
        '--button-color': this.buttonColor
      }
    }
  },
  methods: {
    /**
     * Handle SSO button click
     * @param action 
     */
    async handleActionButton(action) {
      // TODO handle various systems
      let system = 'banking2'
      if (action.target) {
        if (action.target === 'commercial') {
          system = 'banking2'
        } else if (action.target === 'documents') {
          this.$router.push('/mydocuments')
          return
        } else {
          system = action.target
        }
      }
      this.createSsoRequest({ system })
      document.cookie = `ssoRequest=${action.username}`
    },
    /**
     * Build and submit form request to SSO service
     * @param params 
     */
    async createSsoRequest(params) {
      let form = document.createElement('form')
      form.method = 'POST'
      form.action = process.env.VUE_APP_SSO_URL
      let inputs = [
        {
          name: 'system',
          value: params.system
        },
        {
          name: 'token',
          value: this.user.signInUserSession.accessToken.jwtToken
        }
      ]
      for (let input of inputs) {
        let element = document.createElement('input')
        element.value = input.value
        element.name = input.name
        form.appendChild(element)
      }
      document.body.appendChild(form)
      form.submit()
    }
  }
};
</script>

<style lang="scss" scoped>
.main-profile {
  border-top-color: var(--border-color);
}
.v-list__tile__title {
  font-size: 1.05rem;
}
.no-scroll {
  overflow: hidden;
}
h3 {
  font-weight: initial;
}
.theme--light .v-list__tile__sub-title {
  color: #40a7c7;
}
.userProps {
  position: relative;
  .edit {
    position: absolute;
    right: 1rem;
    top: 1rem;
    z-index: 1;
  }
  .v-card {
    // cursor: pointer;
    // &:hover {
    //   background-color: #eee;
    // }
    // .v-list {
    //   &:hover {
    //     background-color: #eee;
    //   }
    // }
  }
}
span {
  color: red;
}
.user-card {
  width: 100%;
}
.admin-link {
  box-shadow: none;
  border: 2px solid var(--button-color);
  color: #212529;
  font-size: 1.1rem;
  border-radius: 4px;
  font-weight: 600;
}
</style>
